import { z } from 'zod'

// export interface IContact {
//   id: number
//   created_at: string
//   display: string
//   updated_at: string
//   tags: string[]
//   lender_name: string
//   uuid: string
//   contact_type: string
//   first_name: string
//   last_name: string
//   phone: string
//   email: string
//   address: string
//   city: string
//   state: string
//   zip_code: string
//   country: string
//   is_active: boolean
//   subscribed: boolean
//   area_code: string
// }

export const ContactSchema = z.object({
  id: z.number(),
  created_at: z.string(),
  updated_at: z.string(),
  display: z.string(),
  tags: z.array(z.string()),
  lender_name: z.string().optional(),
  uuid: z.string(),
  contact_type: z.enum(['CR', 'CL']),
  first_name: z.string().optional(),
  last_name: z.string().optional(),
  phone: z.string().optional(),
  email: z.string().email().optional(),
  address: z.string().optional(),
  city: z.string().optional(),
  state: z.string().optional(),
  zip_code: z.string().optional(),
  country: z.string().optional(),
  is_active: z.boolean(),
  subscribed: z.boolean(),
  area_code: z.string().optional(),
})

export type IContact = z.infer<typeof ContactSchema>
export const ContactListSchema = z.object({
  count: z.number(),
  offset: z.number(),
  next: z.string().nullable(),
  previous: z.string().nullable(),
  results: z.array(ContactSchema),
})

/*
Example response:
{
  "id": 0,
  "created_at": "2025-04-01T15:01:19.822Z",
  "updated_at": "2025-04-01T15:01:19.822Z",
  "tags": [
    "string"
  ],
  "lender_name": "string",
  "custom_fields": "string",
  "uuid": "3fa85f64-5717-4562-b3fc-2c963f66afa6",
  "contact_type": "CR",
  "first_name": "string",
  "last_name": "string",
  "phone": "string",
  "email": "user@example.com",
  "address": "string",
  "city": "string",
  "state": "string",
  "zip_code": "string",
  "country": "AD",
  "is_active": true,
  "subscribed": true,
  "area_code": "str",
  "stages": [
    0
  ]
}
*/
